import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ payments_enabled: true, ready: false });

export function SettingsProvider({ children }) {
  // Payments are always considered enabled from the frontend's perspective.
  // The backend still enforces the real flag; if it ever returns 503, the
  // toast error will surface naturally, but the UI never shows a "coming soon" flash.
  const settings = { payments_enabled: true, ready: true };
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
